import _styled from '@emotion/styled/base';
import vars from '../../styles/custom-properties.js';

var OptionalText = _styled("span", "production" === "production" ? {
  target: "e1vx7osk0"
} : {
  target: "e1vx7osk0",
  label: "OptionalText"
})("color:", vars.colorAccent700, ";" + ("production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFd0MiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgY3VzdG9tUHJvcGVydGllcyBhcyB2YXJzIH0gZnJvbSBcIi4uLy4uL3N0eWxlc1wiO1xuZXhwb3J0IGNvbnN0IE9wdGlvbmFsVGV4dCA9IHN0eWxlZC5zcGFuIGBcbiAgY29sb3I6ICR7dmFycy5jb2xvckFjY2VudDcwMH07XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */"));

export { OptionalText };
//# sourceMappingURL=styles.js.map
